import { Col } from "reactstrap";
import { P, Ribbon } from "../../../../AbstractElements";
import { LEFT_RIBBONS } from "../../../../Data/Bonus Ui/Ribbons";
import { Fragment } from "react";
import { RibbonProp } from "../../../../Type/BonusUi";

export const DynamicLeftRibbons = () => {
  return (
    <>
      {LEFT_RIBBONS.map(({ className, ribbonClass, title, span, icon }: RibbonProp, index) => (
        <Col sm="6" xl="4" key={index}>
          <div className={`border border-1 height-equal ${className ? className : ""}`}>
            <Ribbon className={`ribbon ${ribbonClass}`}>
              {title && title}
              {icon && icon}
            </Ribbon>
            <P className="txt-dark">
              {span.map(({ spanText, text }, index) => (
                <Fragment key={index}>
                  {text && text}
                  {spanText && <em className="txt-danger">{spanText}</em>}
                </Fragment>
              ))}
            </P>
          </div>
        </Col>
      ))}
    </>
  );
};
